import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

import CostLedgerConfigSection from '../components/catalog/CostLedgerConfigSection';
import StockManagerLayout from '../components/StockManagerLayout';

const allowedViews = new Set([
  'ledgers',
  'cost-heads',
  'allocation-rules',
  'product-pack-margins',
  'market-changes',
]);

const CostLedgerConfigPage = () => {
  const { view } = useParams();

  if (view && !allowedViews.has(view)) {
    return <Navigate to="/ecosystem/catalog/cost-ledger-config" replace />;
  }

  return (
    <StockManagerLayout>
      <main className="space-y-4">
        <CostLedgerConfigSection activeView={view || 'overview'} />
      </main>
    </StockManagerLayout>
  );
};

export default CostLedgerConfigPage;
